import axios from 'axios';

const getCostModel = (cancelToken, config) => {
  return axios.get('/api/cost-model/costModel', { cancelToken, ...config });
};

const getOrganizationLevelsByCostCenters = (levelToGet, otherLevel, otherLevelSelectedItems) => {
  return axios.post('/api/cost-model/getOrganizationLevelsByCostCenters', {
    levelToGet: levelToGet,
    otherLevel: otherLevel,
    otherLevelSelectedItems: otherLevelSelectedItems 
  } );
};

const getFiltersForCostAllocation = (objectTypeId, accountTypeId) => {
  return axios.post('/api/cost-model/getFiltersForCostAllocation', {
    objectTypeId: objectTypeId,
    accountTypeId: accountTypeId,
  } );
};

const getPersonnelFilters = () => {
  return axios.get('/api/cost-model/get-personnel-filters');
};

const getNonPersonnelFilters = () => {
  return axios.get('/api/cost-model/get-non-personnel-filters');
};

export {
  getCostModel,
  getOrganizationLevelsByCostCenters,
  getFiltersForCostAllocation,
  getPersonnelFilters,
  getNonPersonnelFilters,
};
